import React, { useState, Fragment, useEffect, useMemo } from 'react'
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import ExportExcelButton from "../../components/exportExcelButton";
import { setLoading } from '../../redux/appSlice'
import { customerdetailreport } from '../../services/reportservice';
import Pagination from '../../components/paginations2';
import { formatCountNumber, formatCountNumber2digit, TrackingSignImageURL } from '../../global';
import { ButtonPrimarySm } from '../../components/formelements';
import ColumnPreferencesModal from './columnsPreferences';
import { getAllTiles, getUserTilesById } from '../../services/dashboardservice';
import axios from "axios";

const dashboardCols = [
  { label: "Order ID", key: "ORDERID" },
  { label: "COD Amount", key: "CODAmount" },
  { label: "Booking Date", key: "BookingDate" },
  { label: "Account #", key: "AccountNo" },
  { label: "Account Title", key: "AccountName" },
  { label: "Consignee Name", key: "ConsigneeName" },
  { label: "Consignee No", key: "ConsigneeNo" },
  { label: "Pickup Location", key: "PickupLocation" },
  { label: "M&P Consignment No.", key: "ConsignmentNumber" },
  { label: "Service", key: "ServiceName" },
  { label: "Origin", key: "OriginBranch" },
  { label: "Destination", key: "DestBranch" },
  { label: "Handover Date", key: "AccountRcvDate" },
  { label: "Pieces", key: "pieces" },
  { label: "Weight", key: "weight" },
  { label: "Current Status", key: "CurrentStatus" },
  { label: "Status Date & Time", key: "TransactionTime" },
  { label: "Delivery Date", key: "deliveryDate" },
  { label: "Failed Delivery Reason", key: "POD_Reason" },
  { label: "Payment ID", key: "PaymentID" },
  { label: "Instrument Number", key: "InstrumentNumber" },
  { label: "Payment Date", key: "PaymentDate" },
  { label: "Invoice Number", key: "InvoiceNumber" },
  { label: "Courier Charges", key: "CourierAmount" },
  { label: "Fuel Adjustment Charges", key: "FAF_Amount" },
  { label: "Variable Fuel Charges", key: "VariableSurCharge" },
  { label: "OSA/NSA Charges", key: "OSANSACharges" },
  { label: "ESC Charges", key: "ESC_Amount" },
  { label: "SSSC Charges", key: "SS_SCH_Amount" },
  { label: "SMS Alert Charges", key: "SMSAlertCharges" },
  { label: "GST Courier Charges", key: "GSTCourierCharges" },
  { label: "GST Fuel Adjustment Charges", key: "FAF_Gst_Total" },
  { label: "GST Variable Fuel Charges", key: "TOTAL_FAF_NP_GST" },
  { label: "GST OSA/NSA Charges", key: "OSANSAGST" },
  { label: "GST ESC Charges", key: "ESC_Gst_Total" },
  { label: "GST SSSC Charges", key: "SS_SCH_gst" },
  { label: "GST SMS Alert Charges", key: "SMSAlertChargesGST" },
  { label: "Total Charges", key: "TotalCharges" },
  { label: "Total GST", key: "TotalGST" },
  { label: "Total Amount", key: "TotalAmount" },
  { label: "Proof Of Delivery", key: "POD" },
  { label: "Payment STATUS", key: "PaymentSTATUS" },
  { label: "Hold For Advice", key: "HoldForAdvice" }
];


const CustomerDetail = () => {
    const dispatch = useDispatch();
    const { accounts, userInfo } = useSelector(state => state.appData)
    const now = new Date();
    const today = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;

    const history = useHistory();

    const d = { 'ReportType': '', 'Accounts': [accounts[0]] };
    const [data, setData] = useState(d);
    const [grid, setGrid] = useState([]);

    //Pagination     
    const [page, setPage] = useState(0);
    const [pageLimit, setPageLimit] = useState(50);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [originalGrid, setOriginalGrid] = useState([]);
    const [imageURLOne, setImageURLOne] = useState([]);
    const [gridWithPOD, setGridWithPOD] = useState([]); // updated grid with POD field
    const [dashboardColumns,  setDashboardColumns] = useState([]);
        // Add these state variables
    const [showColumnPreferences, setShowColumnPreferences] = useState(false);
    const [visibleColumns, setVisibleColumns] = useState([]);

        // Initialize visible columns - first 10 by default
    useEffect(async () => {
          const CancelToken = axios.CancelToken;
          const source = CancelToken.source();
        if (dashboardCols.length > 0 && visibleColumns.length === 0) {
            const defaultColumns = dashboardCols.slice(0, 10).map(col => col.key);
            const tilesRS = await getUserTilesById(userInfo.id, source);
            //setLocalStorage("tilesData", tilesRS.data);
            //setVisibleTiles(tilesRS.data);
            setVisibleColumns(tilesRS.data.length > 0 ? tilesRS.data.map(x => x.name) : defaultColumns);
        }

        const allTilesRes = await getAllTiles(source);
        if (allTilesRes.sts == 0) {
            const { sts, ...restTiles } = allTilesRes;
            setDashboardColumns(restTiles.data.length > 0 ? restTiles.data : dashboardCols);
        }
    }, [dashboardCols]);

    // Filter columns for export based on user preferences
    const getFilteredColumnsForExport = () => {
      return dashboardColumns.filter(column => visibleColumns.includes(column.key));
    };


    // Filter gridKeys based on visible columns
    const getFilteredGridKeys = () => {
      return gridKeys.filter(keyConfig => 
        keyConfig.key === '' || visibleColumns.includes(keyConfig.key)
      );
    };


    useEffect(() => {
        const fetchAllPODs = async () => {
            const updatedGrid = [...originalGrid]; // clone original data
            const podChecks = await Promise.all(
                updatedGrid.map(async (item) => {
                    if (item.CurrentStatus === "Delivered") {
                        const result = await isImageAvailable(TrackingSignImageURL, item.ConsignmentNumber);
                            setImageURLOne(prev => [...prev, {cn: result.cn, url: result.pod, showImage: result?.pod.length > 0 ?  true : false}])
                        return { ...item, POD: result.pod,  TotalAmount:  item.TotalCharges + item.TotalGST, 
                                OSANSACharges: item.NonServiceArea + item.OutofServiceArea,
                                OSANSAGST: item.NonServiceAreaGST + item.OutofServiceAreaGST };
                    } else {
                        return { ...item, POD: '', TotalAmount:  item.TotalCharges + item.TotalGST,
                                OSANSACharges: item.NonServiceArea + item.OutofServiceArea,
                                OSANSAGST: item.NonServiceAreaGST + item.OutofServiceAreaGST

                        };
                    }
                })
            );
            setGridWithPOD(podChecks);
        };

        fetchAllPODs();
    }, [originalGrid]);

    
    const isImageAvailable = async (urlParam, cn) => {
        return new Promise((resolve) => {
            const url = `${urlParam}/${cn}.jpg`;
            const image = new Image();

            image.onload = function () {
                if (this.width > 0) {
                    resolve({ cn, pod: url });
                } else {
                    resolve({ cn, pod: '' });
                }
            };

            image.onerror = function () {
                resolve({ cn, pod: '' });
            };

            image.src = url;
        });
    };
    
    const searchObjInit = {
        ORDERID: '',
        CODAmount: '',
        BookingDate: '',
        ConsignmentNumber: '',
        ConsigneeName: '',
        ServiceName: '',
        DestBranch: '',
        AccountRcvDate: '',
        CurrentStatus: '',
        TransactionTime: '',
        deliveryDate: '',
        InvoiceNumber: '',
        PaymentID: ''
    };

    function trimString(s) {  
        var l=0, r=s.length -1;
        while(l < s.length && s[l] == ' ') l++;
        while(r > l && s[r] == ' ') r-=1;
        return s.substring(l, r+1);
    }


    const [searchObject, setSearchObj] = useState(searchObjInit);
    const updateSearchData = (key, val) => setSearchObj(prev => { return { ...prev, [key]: val } });

    const gridKeys = [  
        {key: 'ORDERID', name: 'Order ID', searchBox: true, visible: true},
        {key: 'CODAmount', name: 'COD Amount', searchBox: true, visible: true},
        {key: 'BookingDate', name: 'Booking Date', searchBox: true, visible: true},
        {key: 'AccountNo', name: 'Account #', searchBox: true, visible: true},
        {key: 'AccountName', name: 'Account Title', searchBox: true, visible: true},
        {key: 'ConsigneeName', name: 'Consignee Name', searchBox: false, visible: true},
        {key: 'ConsigneeNo', name: 'Consignee No.', searchBox: false, visible: true},
        {key: 'PickupLocation', name: 'Pickup Location', searchBox: false, visible: true},
        {key: 'ConsignmentNumber', name: 'M&P Consignment No.', searchBox: true, visible: true},
        {key: 'ServiceName', name: 'Service', searchBox: true, visible: true},
        {key: 'OriginBranch', name: 'Origin', searchBox: false, visible: true}, 
        {key: 'DestBranch', name: 'Destination', searchBox: true, visible: true},
        {key: 'AccountRcvDate', name: 'Handover Date', searchBox: true, visible: true},
        {key: 'pieces', name: 'Pieces', searchBox: false, visible: true},
        {key: 'weight', name: 'Weight', searchBox: false, visible: true},
        // {key: 'ExpectedDeliveryDate', name: 'Expected Delivery Date', searchBox: true, visible: true},
        // {key: 'ExpectedReturnDate', name: 'Expected Return Date', searchBox: false, visible: true},
        // {key: 'agreedattempts', name: 'Agreed Attempts', searchBox: true, visible: true},
        // {key: 'ActualAttempts', name: 'Actual Attempts', searchBox: false, visible: true},
        {key: 'CurrentStatus', name: 'Current Status', searchBox: true, visible: true},
        {key: 'TransactionTime', name: 'Status Date & Time', searchBox: true, visible: true},
        {key: 'deliveryDate', name: 'Delivery Date', searchBox: true, visible: true},
        {key: 'POD_Reason', name: 'Failed Delivery Reason', searchBox: false, visible: true},
        // {key: 'DeliveryAging_WorkingDays', name: 'Ageing', searchBox: true, visible: true},  // ReturnAging_WorkingDays
        // {key: 'Delivery_SLA', name: 'Shipment TAT Compliance', searchBox: false, visible: true},  //Return_SLA
        // {key: 'PaymentTATCompliance', name: 'Payment TAT Compliance', searchBox: true, visible: true},
        {key: 'PaymentID', name: 'Payment ID', searchBox: true, visible: true},
        {key: 'InstrumentNumber', name: 'Instrument Number', searchBox: false, visible: true},
        {key: 'PaymentDate', name: 'Payment Date', searchBox: false, visible: true},  
        {key: 'InvoiceNumber', name: 'Invoice Number', searchBox: false, visible: true},  
        {key: 'CourierAmount', name: 'Courier Charges', searchBox: false, visible: true},
        {key: 'FAF_Amount', name: 'Fuel Adjustment Charges', searchBox: false, visible: true},
        {key: 'VariableSurCharge', name: 'Variable Fuel Charges', searchBox: false, visible: true}, 
        {key: 'NonServiceArea', name: 'OSA/NSA Charges', searchBox: false, visible: true},  // NonServiceArea + OutofServiceArea
        {key: 'ESC_Amount', name: 'ESC Charges', searchBox: false, visible: true},  
        {key: 'SS_SCH_Amount', name: 'SSSC Charges', searchBox: false, visible: true},
        {key: 'SMSAlertCharges', name: 'SMS Alert Charges', searchBox: false, visible: true},
        {key: 'GSTCourierCharges', name: 'GST Courier Charges', searchBox: false, visible: true},
        {key: 'FAF_Gst_Total', name: 'GST Fuel Adjustment Charges', searchBox: false, visible: true},
        {key: 'TOTAL_FAF_NP_GST', name: 'GST Variable Fuel Charges', searchBox: false, visible: true},
        {key: 'NonServiceAreaGST', name: 'GST OSA/NSA Charges', searchBox: false, visible: true},  // OutofServiceAreaGST
        {key: 'ESC_Gst_Total', name: 'GST ESC Charges', searchBox: false, visible: true},
        {key: 'SS_SCH_gst', name: 'GST SSSC Charges', searchBox: false, visible: true},
        {key: 'SMSAlertChargesGST', name: 'GST SMS Alert Charges', searchBox: false, visible: true},
        
        {key: 'TotalCharges', name: 'Total Charges', searchBox: false, visible: true},
        {key: 'TotalGST', name: 'Total GST', searchBox: false, visible: true},
        {key: 'TotalAmount', name: 'Total Amount', searchBox: false, visible: true},
        {key: 'POD', name: 'Proof Of Delivery', searchBox: false, visible: true},

        {key: 'PaymentSTATUS', name: 'Payment STATUS', searchBox: false, visible: true},
        {key: 'HoldForAdvice', name: 'Hold For Advice', searchBox: false, visible: true},

        {key: '', name: 'Action', searchBox: false, visible: true}

    ]

    
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
          direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    let filterData = useMemo(() => {
        return grid.filter((item, index) => {
            return (index >= page * pageLimit) & (index < (page + 1) * pageLimit);
        })
    }, [page, grid, pageLimit, grid.length]);

    const sortedArray = [...filterData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });

    useEffect(() => {
        const load = async () => {
            const detail = JSON.parse(sessionStorage.getItem('customerdetail'));
            
            sessionStorage.removeItem('customerdetail');

            if (!detail?.detailtype) {
                alert('No Report Type found');
                return;
            }
            if (!data?.Accounts) {
                alert('No Account found');
                return;
            }

            dispatch(setLoading({ data: true }));
            
            const filtOne = { ...data, ReportType: detail.detailtype }

            if (detail?.filterUsed) {
              filtOne["StartDate"] = detail.start;
              filtOne["EndDate"] = detail.end;
              filtOne["accounts"] = detail.accounts;
              filtOne["subAccountId"] = detail.subAccountId;
              filtOne["locationID"] = detail.locationID;
              filtOne["destIds"] = detail.destIds;
              filtOne["originIds"] = detail.originIds;
            }

            var rs = await customerdetailreport(filtOne);

            dispatch(setLoading({ data: false }));
            if (rs.sts == 0) {
                if (rs.data.length > 0) {
                    setOriginalGrid(rs.data);
                    setGrid(rs.data);
                }
                else {
                    alert('No Data Found');
                    setGrid([]);
                    setOriginalGrid([]);
                }
            }
            else {
                alert(rs.msg);
                setGrid([]);
                setOriginalGrid([]);
            }

            setData({ ...data, ReportType: detail.heading });
        }
        load();
    }, [])


    return <section className="section">
        <div className="section-header" style={{
            marginTop: '4px',
            borderRadius:'4px',
            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.12)'
        }}>
            <h1>Shipment Details
                    <span className="current-month">
                        ({data.ReportType})
                    </span> 
            </h1>
        </div>
        <div className="card" style={{ padding: '4px 10px' }}>

            {
                originalGrid && originalGrid.length > 0 &&
                <div className="row pb-2">
                    <div className="col-12">
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                            <h5  className="report-heading-counts">Total Records: {originalGrid.length}</h5>
                            <div style={{ textAlign: 'right',marginBottom: '5px', position: 'relative', top: '-5px' }}>
                                <button 
                                    style={{ marginRight: '2px' }}
                                    className = "btn btn-sm btn-primary shipmentdetail-count-buttons"                                
                                    onClick={() => setShowColumnPreferences(true)}
                                    >
                                        Adjust columns
                                </button>
                                <ExportExcelButton data={gridWithPOD} 
                                                columns={getFilteredColumnsForExport()} 
                                                fileName="Dashboard_Count_Report"
                                                className="btn btn-sm btn-primary shipmentdetail-count-buttons"
                                />
                            </div>
                        </div>

                        <Pagination
                            setGrid={setGrid}
                            searchObjInit={searchObjInit}
                            searchObject={searchObject}
                            originalGrid={originalGrid}
                            setPage={setPage}
                            setPageLimit={setPageLimit}
                            requestSort={requestSort}
                            sortConfig={sortConfig}
                            updateSearchData={updateSearchData}
                            sortedArray={sortedArray}
                            data={data}
                            dataCount={grid.length}
                            pageLimit={pageLimit}  
                            gridrender={sortedArray}
                            gridKeys={gridKeys}
                            page={page}
                            grid={
                                
                                <div className="table-responsive" style={{ height: '60vh', position: 'relative' }}>
                                <table className="table table-bordered table-shipment-size">
                                    <thead>
                                    <tr>
                                        <th className="th-datatable" style={{ position: 'sticky', top: 0, background: 'white', zIndex: 500 }}>S. No.</th>
                                        
                                        {/* HEADER ROW - Only show selected columns */}
                                        {getFilteredGridKeys().map((e,i) => 
                                        e.visible ?  
                                        <th 
                                            style={{ position: 'sticky', top: 0, background: 'white', zIndex: 500 }}
                                            className={e.key === '' ? "th-datatable" : "th-datatable cursor-pointer"}
                                            onClick={() => {
                                                requestSort(e.key === '' ? 'NoArrow' : e.key)
                                            }}
                                            title="Sort"
                                            key={i}
                                        >
                                            {e.name} 
                                            <i 
                                            className={`
                                                        
                                                        ${sortConfig.key === e.key ? 'icon-setting-color' : ''}
                                                        ${
                                                            e.key != '' && e.key != 'POD' ? 
                                                                sortConfig.key === e.key && sortConfig.direction === 'ascending'
                                                                    ? 'icon-setting fa fa-arrow-up'
                                                                    : 'icon-setting fa fa-arrow-down'
                                                            : ''
                                                         }
                                                    `}
                                            aria-hidden="true"
                                            ></i>
                                        </th> : null
                                        )}
                                    </tr>
                                    
                                    {/* SEARCH ROW - Only show search boxes for selected columns */}
                                    <tr key={'start'}>
                                        <td key={'he2'}></td>
                                        {getFilteredGridKeys().map((g, i) => {
                                        return g.visible ?  
                                        g.searchBox ? 
                                            <td key={i}>
                                            <input 
                                                type="text"  
                                                onChange={(e) => {
                                                updateSearchData(g.key, trimString(e.target.value));
                                                }}  
                                                className="inp" 
                                                placeholder={g.name} 
                                            />
                                            </td> : 
                                            <td key={i}></td>
                                        : null
                                        })}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {/* DATA ROWS - Only show data for selected columns */}
                                    {sortedArray && sortedArray.length > 0 && sortedArray.map((x, index) => (
                                        <tr key={index}>
                                        <td>{(index + 1) + (page * pageLimit)}</td>
                                        
                                        {/* Dynamically render only visible columns */}
                                        {getFilteredGridKeys().map((g, i) => {
                                            if (!g.visible) return null;
                                            
                                            switch(g.key) {
                                            case 'ORDERID':
                                                return <td key={i}>{x.ORDERID}</td>;
                                            case 'CODAmount':
                                                return <td key={i}>{x.CODAmount}</td>;
                                            case 'BookingDate':
                                                return <td key={i}>{x.BookingDate}</td>;
                                            case 'AccountNo':
                                                return <td key={i}>{x.AccountNo}</td>;
                                            case 'AccountName':
                                                return <td key={i}>{x.AccountName}</td>;
                                            case 'ConsigneeName':
                                                return <td key={i}>{x.ConsigneeName}</td>;
                                            case 'ConsigneeNo':
                                                return <td key={i}>{x.ConsigneeNo}</td>;
                                            case 'PickupLocation':
                                                return <td key={i}>{x.PickupLocation}</td>;
                                            case 'ConsignmentNumber':
                                                return (
                                                <td key={i}>
                                                    <span 
                                                    style={{ color: '#EA5B0C', cursor: 'pointer' }} 
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        sessionStorage.setItem('cn', x.ConsignmentNumber);
                                                        window.open('/cplight/tracking_2', '_blank');
                                                    }}
                                                    >
                                                    {x.ConsignmentNumber}
                                                    </span>
                                                </td>
                                                );
                                            case 'OSA/NSA Charges': 
                                                return <td key={i}>{x.NonServiceArea + x.OutofServiceArea}</td>
                                            case 'GST OSA/NSA Charges': 
                                                return <td key={i}>{x.NonServiceAreaGST + x.OutofServiceAreaGST}</td>
                                            case 'TotalAmount': 
                                                return <td key={i}>{formatCountNumber2digit(x.TotalCharges + x.TotalGST)}</td>
                                                

                                            case 'POD': // Proof Of Delivery
                                                return (
                                                <td key={i}>
                                                    {imageURLOne.filter(e => e.cn == x.ConsignmentNumber)[0]?.showImage == true &&  
                                                    <div>
                                                        <a 
                                                        href={imageURLOne.filter(e => e.cn == x.ConsignmentNumber)[0]?.url} 
                                                        className="btn btn-sm btn-primary" 
                                                        type="image/JPEG" 
                                                        target="_blank"
                                                        style={{    width: '101px'}}
                                                        >
                                                        View Signature
                                                        </a>
                                                    </div>
                                                    }
                                                </td>
                                                );
                                            case '': // Action column
                                                return (
                                                <td key={i}>
                                                    <div style={{ width: '98px' }}>
                                                    <ButtonPrimarySm 
                                                        text={(!x.TicketStatus || x.TicketStatus === 0) ? 'Launch Ticket' : 'View Ticket'} 
                                                        onClick={e => {
                                                        sessionStorage.setItem('complaintData', JSON.stringify({
                                                            cn: x.ConsignmentNumber,
                                                            codAmount: x.CODAmount,
                                                            screen: 'tracking_2'
                                                        }));
                                                        window.open('/cplight/complaint', '_blank');
                                                        }} 
                                                    />
                                                    </div>
                                                </td>
                                                );
                                            default:
                                                // For other columns, simply display the value
                                                return <td key={i}>{x[g.key]}</td>;
                                            }
                                        })}
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                                </div>
                            }
                        />
                    </div>
                </div>
            }

             {/* Column Preferences Modal */}
            {showColumnPreferences && (
                <ColumnPreferencesModal
                    userId={userInfo.id}
                    setShowModal={setShowColumnPreferences}
                    visibleColumns={visibleColumns}
                    setVisibleColumns={setVisibleColumns}
                    allColumns={dashboardColumns}
                />
            )}
        </div>
    </section>
}

export default CustomerDetail;